<template>
    <VMultiselect
        v-model="selectedAddress"
        :options="addresses"
        track-by="label"
        :custom-label="option => option.label"
        :searchable="true"
        :loading="isLoading"
        :internal-search="false"
        :clear-on-select="true"
        :placeholder="placeholder || $t('typeToSearch')"
        :multiple="false"
        :allow-empty="false"
        :close-on-select="true"
        :hide-selected="false"
        :show-labels="false"
        @search-change="asyncFind"
        @input="$emit('input', selectedAddress)"
    >
        <template #noOptions>
            {{ $t('noOptions') }}
        </template>

        <template #noResult>
            {{ $t('noResult') }}
        </template>
    </VMultiselect>
</template>

<script>
import { debounce } from 'lodash'
import VMultiselect from 'vue-multiselect'

import { httpHelper } from '@/utils'

export default {
    name: 'AddressSearch',
    components: {
        VMultiselect,
    },
    props: {
        placeholder: {
            type: String,
            default: null,
        },
        defaultAddress: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            addresses: [],
            isLoading: false,
            selectedAddress: {},
        }
    },
    watch: {
        defaultAddress(address) {
            if (
                (address && this.addresses.length === 0) ||
                this.addresses !== [address]
            ) {
                this.addresses = [address]
                this.selectedAddress = address
            }
        },
    },
    mounted() {
        if (this.defaultAddress) {
            this.addresses = [this.defaultAddress]
            this.selectedAddress = this.defaultAddress
        }
    },
    methods: {
        asyncFind: debounce(async function(query) {
            if (!query.length) {
                return
            }

            this.isLoading = true
            const { data } = await httpHelper.get('/positionstack/forward/', {
                params: {
                    language: this.$i18n.locale,
                    query,
                },
            })
            this.addresses = [
                ...data.data,
                ...(this.defaultAddress ? [this.defaultAddress] : []),
            ]
            this.isLoading = false
        }, 400),
    },
}
</script>

<i18n>
{
    "en": {
        "noOptions": "Start to type to get address results",
        "noResult": "No results were found",
        "typeToSearch": "Type to search address"
    },
    "de": {
        "noOptions": "Starte zu tippen um Adressen anzuzeigen",
        "noResult": "Keine Resultate gefunden",
        "typeToSearch": "Hier nach Adresse suchen"
    },
    "fr": {
        "noOptions": "Commencez à taper pour obtenir des résultats d'adresse",
        "noResult": "Aucun résultat trouvé",
        "typeToSearch": "Tapez pour rechercher l'adresse"
    },
    "it": {
        "noOptions": "Inizia a digitare per ottenere i risultati dell'indirizzo",
        "noResult": "Non sono stati trovati risultati",
        "typeToSearch": "Digitare l'indirizzo da cercare"
    }
}
</i18n>
